import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DocumentFile } from '../../../../core/models/document-file-model';
import { FileContainerComponent } from '../../../file-descriptor/components/file-container/file-container.component';
import { DocumentUploadService } from '../../../../core/services/api/document-upload.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IBasicModalComponentInstance } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import { BasicModalOperationResult, DialogModalComponent } from '../../../../shared/components/dialog-modal/dialog-modal.component';
import { GuidHelper } from '../../../../core/helpers/guid-helper';
import { DefaultDocumentProcess, DocumentProcess } from '../../../../core/models/document-process.model';
import { ComponentCanDeactivate } from 'src/app/core/guards/pending-changes.guard';
import { Observable } from 'rxjs';
import { DismissReason } from 'src/app/shared/extensions/ng-active-modal/dismiss-reason';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { NgxLoadingComponent } from 'ngx-loading';
import { DefaultDocumentProcessTo, DocumentProcessTo } from '../../../../core/models/document-process-to.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UploadNewInviteComponent } from './upload-new-invite/upload-new-invite.component';
import { ConstancyType } from 'src/app/core/models/enums/constancyType';

@Component({
  selector: 'app-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss']
})
export class UploadDocumentComponent implements ComponentCanDeactivate {
  showSpinner: boolean = false;
  submitting: boolean = false;
  hasSubmittedData: boolean = false;
  documentProcess: DocumentProcess = DefaultDocumentProcess();
  @ViewChild("fileContainer") fileContainer: FileContainerComponent;
  ngxLoadingComponent!: NgxLoadingComponent;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  documentProcessToOptions: DocumentProcessTo[];
  documentProcessToOptionsAux: DocumentProcessTo[];
  documentProcessToAssigns: DocumentProcessTo[];
  newUserDocumentProcessTo: DocumentProcessTo = DefaultDocumentProcessTo();
  selected: boolean = false;
  constancyType = ConstancyType;
  constancyTypeKeys = [];
  optionsCounter: number = 0;
  selectedItem: string="";

  form = new FormGroup({
    signature: new FormControl('', Validators.required),
    read: new FormControl('', Validators.required)
  });

  constructor(
    public translate: TranslateService,
    private documentUploadService: DocumentUploadService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
  ) {
    this.constancyTypeKeys = this.enumValues(this.constancyType);
  }

  enumKeys(target: Record<string, number | string>): string[] {
    const allKeys: string[] = Object.keys(target);
    const parsedKeys: string[] = [];

    for (const key of allKeys) {
      const needToIgnore: boolean
        = target[target[key]]?.toString() === key && !isNaN(parseInt(key));

      if (!needToIgnore) {
        parsedKeys.push(key);
      }
    }

    return parsedKeys;
  }

  enumValues(target: Record<string, number | string>): Array<string | number> {
    const keys: string[] = this.enumKeys(target);
    const values: Array<string | number> = [];

    for (const key of keys) {
      values.push(target[key]);
    }

    return values;
  }

 
  async ngOnInit(): Promise<void> {

    this.documentProcessToOptions = await this.documentUploadService.loadDocumentProcessToOptions();
    this.documentProcessToOptionsAux = this.documentProcessToOptions;
    this.documentProcessToAssigns = new Array<DocumentProcessTo>();
  }

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    let hasPendingChanges = this.hasPendingChanges();
    let canLeave =
      !hasPendingChanges || (hasPendingChanges && this.hasSubmittedData);
    return canLeave;
  }

  async uploadDocument() {
    try {
      this.submitting = true;
      this.showSpinner = true;

      if (this.fileContainer) {
        await this.fileContainer.commitFiles();
      }
      this.documentProcess.documentProcessToAssigns = this.documentProcessToAssigns;

      await this.documentUploadService.upload(this.documentProcess);

      const modalRef = this.modalService.open(DialogModalComponent, {
        backdrop: "static",
        keyboard: false,
      });

      const modalInstance =
        modalRef.componentInstance as IBasicModalComponentInstance;
      modalInstance.title = this.translate.instant("documentsUpload.uploadedDocument");
      modalInstance.body = this.translate.instant("documentsUpload.uploadedDocument");

      modalInstance.type = BasicModalOperationResult.Success;

      await modalRef.result;
      this.documentProcess = DefaultDocumentProcess();
      this.showSpinner = false;
      this.submitting = false;
      this.activeModal.close(DismissReason.Saved);
    } catch (error) {
      this.showSpinner = false;
      this.hasSubmittedData = false;
      this.submitting = false;
    }
  }

  isAbleToUpload() {
    let isValidToSave = false;

    if (
      this.documentProcess &&
      this.documentProcess.constancyType != '' &&
      this.documentProcess.constancyNumber != '' &&
      this.documentProcess.registrationNumber != '' &&
      this.documentProcess.documentFile &&
      this.documentProcess.assingTo &&
      this.documentProcess.documentFile.fileDescriptorId &&
      !GuidHelper.isEmptyGuid(
        this.documentProcess.documentFile.fileDescriptorId
      )
    ) {
      isValidToSave = true;
    }

    return isValidToSave;
  }

  hasPendingChanges() {
    let hasPendingChanges =
      (this.documentProcess.constancyType != '') ||
      (this.documentProcess.constancyNumber != '') ||
      (this.documentProcess.registrationNumber != '') ||
      (this.documentProcess.documentFile.fileDescriptorId &&
        !GuidHelper.isEmptyGuid(
          this.documentProcess.documentFile.fileDescriptorId
        ))
    return hasPendingChanges;
  }

  closeModal() {
    if (this.hasPendingChanges()) {
      const modalRef = this.modalService.open(DialogModalComponent, {
        backdrop: "static",
        keyboard: false,
      });

      const modalInstance =
        modalRef.componentInstance as IBasicModalComponentInstance;
      modalInstance.title = this.translate.instant(
        "pendingChangesGuard.modalTitle"
      );
      modalInstance.type = BasicModalOperationResult.Warning;
      modalInstance.body = this.translate.instant(
        "pendingChangesGuard.modalBody"
      );
      modalInstance.buttons = [
        {
          text: this.translate.instant("pendingChangesGuard.cancel"),
          cssClass: "btn btn-outline-dark",
          handler: async (btn) => {
            modalInstance.closeModal();
          },
        },
        {
          closeModalOnClick: false,
          text: this.translate.instant("pendingChangesGuard.accept"),
          cssClass: "btn btn-success",
          handler: (btn) => {
            modalInstance.closeModal();
            this.activeModal.close(DismissReason.Cancelled);
          },
        },
      ];
    } else {
      this.activeModal.close(DismissReason.Cancelled);
    }
  }

  addAssignTo(id: number) {
    var document = new DocumentProcessTo();
    document = this.documentProcessToOptions.find(x => x.id == id);
    this.documentProcessToAssigns.push(document);
  }

  public onOptionsSelected(event) {
    this.selected = true;
    
    let item = this.documentProcessToOptions.find(x => (x.firstName +", " + x.lastName + "-" + x.sintraId + " " + x.textFlag).trim() === (event.target.value).trim());
    if(item != undefined){
      var documentProcessTo = new DocumentProcessTo();
      // buscar en la lista, si está, no ingresarla.
      documentProcessTo = this.documentProcessToOptions.find(x => x.id == item.id && x.isOrganization == item.isOrganization);
      this.addDocumentProcessToAssigns(documentProcessTo);
      this.selectedItem = "";
    }
  }

  private addDocumentProcessToAssigns(documentProcessTo:DocumentProcessTo) {
    if(documentProcessTo!=null){
      let notIncluded = (this.documentProcessToAssigns.find(x => x.sintraId == documentProcessTo.sintraId && x.isOrganization == documentProcessTo.isOrganization)== undefined);
      if(notIncluded && documentProcessTo!= undefined){
        this.documentProcessToAssigns.push(documentProcessTo);
        this.optionsCounter++;     
        this.selected = true;
      }
    }
  }

  removeAssigned(sintraId, isOrganization){
    let documentProcessTo = this.documentProcessToOptions.find(x => x.sintraId == sintraId && x.isOrganization == isOrganization);
    
    const modalInstance = this.modalService.open(DialogModalComponent)
      .componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant(
      "documentsUpload.eliminateAssignedTitle"
    );
    modalInstance.body = this.translate.instant(
      "documentsUpload.eliminateAssignedBody",
      { name: documentProcessTo.firstName +", " + documentProcessTo.lastName + "-" + documentProcessTo.sintraId}
    );
    modalInstance.type = BasicModalOperationResult.Warning;

    modalInstance.buttons = [
      {
        text: this.translate.instant("cancel"),
        cssClass: "btn btn-danger",
        closeModalOnClick: true,
      },
      {
        text: this.translate.instant("confirm"),
        cssClass: "btn btn-success",
        closeModalOnClick: true,
        handler: async () => {
          this.documentProcessToAssigns.forEach((x,index)=>{
            if(x.sintraId == sintraId && x.isOrganization == isOrganization) 
            {
              this.documentProcessToAssigns.splice(index,1);
              this.optionsCounter--;     
            }
         });
        },
      },
    ];
  }

  
  
  changeRadioSelector(e, sintraId, isOrganization) {
    if (e.target.value == 1) {
      this.documentProcessToAssigns.forEach(item => {
        if (item.sintraId == sintraId && item.isOrganization == isOrganization) {
          item.isSignatory = true;

        }
      });
    }
    else {
      this.documentProcessToAssigns.forEach(item => {
        if (item.sintraId == sintraId && item.isOrganization == isOrganization) {
          item.isSignatory = false;
        }
      });

    }

  }

  async addInviteAssignTo() {

    var newPatient = new DocumentProcessTo();

    const modalRef = this.modalService.open(UploadNewInviteComponent, {
      backdrop: "static",
      keyboard: false,
      centered: true,
      size: "lg",
    });

    modalRef.componentInstance.newUserDocumentProcessTo = this.newUserDocumentProcessTo;
     
    let newUserDocumentProcessTo = await modalRef.result.then(
      (result) => {
        if (result) {
          this.documentProcessToOptions.push(this.newUserDocumentProcessTo);
          return result;
        }
       return null;
      });
      this.addDocumentProcessToAssigns(newUserDocumentProcessTo);
      this.newUserDocumentProcessTo = DefaultDocumentProcessTo();
      
  }

  nameValue(name: any) {
    console.log(name);
  }

}
